import { graphql } from '../generated/gql'

// Query to get all users from agencies (flattened)
export const LIST_ALL_USERS_QUERY = graphql(`
  query ListAllUsers($filters: UserFilters, $sort: SortOptions, $pagination: PaginationOptions) {
    listUsers(filters: $filters, sort: $sort, pagination: $pagination) {
      users {
        id
        email
        firstName
        lastName
        roles
        agencyId
        createdAt
        updatedAt
        lastLogin
        deletedAt
        active
        userPermissions {
          id
          userId
          permissionId
          grantedAt
          grantedBy
          expiresAt
          permission {
            id
            name
            description
            category
            isPredefined
            createdAt
            updatedAt
          }
        }
        userAgencies {
          agencyId
          agencyName
          userType
          createdAt
          updatedAt
        }
      }
      totalUsers
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`)

// Query to get all agents for users management
export const LIST_ALL_USERS_AGENTS_QUERY = graphql(`
  query ListAllUsersAgents {
    listAllAgents {
      userId
      email
      firstName
      lastName
      roles
      picUrl
      createdAt
      updatedAt
      lastLogin
      deletedAt
      agency {
        id
        name
        descriptions {
          text
          language
        }
      }
    }
  }
`)

// Query to get agent by email
export const GET_AGENT_BY_EMAIL = graphql(`
  query GetAgentByEmail($email: String!) {
    agentByEmail(email: $email) {
      userId
      email
      firstName
      lastName
      roles
      picUrl
      createdAt
      updatedAt
      lastLogin
      deletedAt
    }
  }
`)

// Query to get a single user by ID
export const GET_USER_QUERY = graphql(`
  query GetUser($userId: String!) {
    getUser(userId: $userId) {
      id
      email
      firstName
      lastName
      roles
      agencyId
      createdAt
      updatedAt
      lastLogin
      deletedAt
      active
      userPermissions {
        id
        userId
        permissionId
        grantedAt
        grantedBy
        expiresAt
        permission {
          id
          name
          description
          category
          isPredefined
          createdAt
          updatedAt
        }
      }
      userAgencies {
        agencyId
        agencyName
        userType
        createdAt
        updatedAt
      }
      loginHistory {
        id
        userId
        ipAddress
        deviceInfo
        userAgent
        successful
        createdAt
      }
    }
  }
`)

// Mutation to add a new agent
export const ADD_AGENT_MUTATION = graphql(`
  mutation AddAgent($input: SignupInput!) {
    addAgent(input: $input) {
      success
      message
      agent {
        userId
        email
        firstName
        lastName
        roles
        picUrl
        createdAt
        updatedAt
        lastLogin
        deletedAt
      }
    }
  }
`)

// Mutation to create a new user
export const CREATE_USER_MUTATION = graphql(`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      email
      firstName
      lastName
      roles
      agencyId
      createdAt
      updatedAt
      lastLogin
      deletedAt
      active
    }
  }
`)

// Mutation to update an agent
export const UPDATE_AGENT_MUTATION = graphql(`
  mutation UpdateAgent($agentId: String!, $input: SignupInput!) {
    updateAgent(agentId: $agentId, input: $input)
  }
`)

// Mutation to update a user
export const UPDATE_USER_MUTATION = graphql(`
  mutation UpdateUser($userId: String!, $input: UpdateUserInput!) {
    updateUser(userId: $userId, input: $input) {
      id
      email
      firstName
      lastName
      roles
      agencyId
      createdAt
      updatedAt
      lastLogin
      deletedAt
      active
    }
  }
`)

// Mutation to remove an agent
export const REMOVE_AGENT_MUTATION = graphql(`
  mutation RemoveAgent($agentId: String!) {
    removeAgent(agentId: $agentId)
  }
`)

// Mutation to delete a user
export const DELETE_USER_MUTATION = graphql(`
  mutation DeleteUser($userId: String!) {
    deleteUser(userId: $userId)
  }
`)

// Mutation to reset user password
export const RESET_USER_PASSWORD_MUTATION = graphql(`
  mutation ResetUserPassword($userId: String!) {
    resetUserPassword(userId: $userId) {
      success
      message
      email
      method
    }
  }
`)

// Mutation for bulk delete users
export const BULK_DELETE_USERS_MUTATION = graphql(`
  mutation BulkDeleteUsers($userIds: [String!]!) {
    bulkDeleteUsers(userIds: $userIds) {
      success
      message
      processedIds
      failedIds
    }
  }
`)

// Query to search users
export const SEARCH_USERS_QUERY = graphql(`
  query SearchUsers($query: String!) {
    searchUsers(query: $query) {
      id
      email
      firstName
      lastName
      roles
      agencyId
      createdAt
      updatedAt
      lastLogin
      deletedAt
      active
    }
  }
`)

// Admin authentication mutations
export const ADMIN_LOGIN_MUTATION = graphql(`
  mutation AdminLogin($input: LoginInput!) {
    adminLogin(input: $input) {
      user {
        id
        email
        firstName
        lastName
        roles
        agencyId
        createdAt
        updatedAt
      }
      accessToken
    }
  }
`)

// Admin user info query
export const ADMIN_ME_QUERY = graphql(`
  query AdminMe {
    adminMe {
      id
      email
      firstName
      lastName
      roles
      agencyId
      createdAt
      updatedAt
    }
  }
`)

// Role assignment mutations
export const ASSIGN_AGENCY_ROLE_MUTATION = graphql(`
  mutation AssignAgencyRole($userId: String!, $role: String!, $agencyId: String!) {
    assignAgencyRole(userId: $userId, role: $role, agencyId: $agencyId)
  }
`)

export const REMOVE_AGENCY_ROLE_MUTATION = graphql(`
  mutation RemoveAgencyRole($userId: String!, $role: String!) {
    removeAgencyRole(userId: $userId, role: $role)
  }
`)
